module.exports = __webpack_public_path__ + "static/img/products discription_tape PVC1.adaac917.jpg";